import Text from "components/Text/Text"
import styles from './BaseballCard.module.scss';
import { ReactComponent as MailIcon } from "assets/email.svg";
import { ReactComponent as SummaryIcon } from "assets/summary.svg";
import { ReactComponent as DetailsIcon } from "assets/details.svg";
import { ReactComponent as CheckInIcon } from "assets/check_in.svg";
import { ReactComponent as NotesIcon } from "assets/notes.svg";
import { ReactComponent as NavigationArrowIcon } from "assets/navigationArrowRight.svg";
import { ReactComponent as StatsIcon } from "assets/stats.svg";
//import { ReactComponent as ExpandIcon } from "assets/expand.svg";
import { ReactComponent as MoneyIcon } from "assets/CurrencyCircleDollar.svg";
import { ReactComponent as InfoIcon } from 'assets/info.svg';
import { ReactComponent as LeftIcon } from "assets/caretleft.svg";

import SendTab from "./components/SendTab";
import React from "react";
import Summary from "./modules/Summary";
import Notes from "./modules/Notes";
import CheckIn from "./modules/CheckIn";
import ListCustomers from "Modules/MapRouter/modules/ListCustomers";
import { store } from "stores/Store";
import { date2usDotDate } from "helpers";
import PractitionerDetails from "./modules/Details";
import Opportunities from "Modules/Opportunities";
import useExternalApiService from "helpers/ExternalApiService";
import Stats from "./modules/Stats";
import { observer } from "mobx-react";
import { useNavigate } from "react-router-dom";
import { getLeadStateByPractitioner } from "helpers/lead";
import RoutesTab from './components/RoutesTab';

import { logEvent } from '@amplitude/analytics-browser'; // ← browser SDK

export enum Tab {
  SUMMARY = "summary",
  DETAILS = "details",
  CHECK_IN = "check_in",
  NOTES = "notes",
  OPPORTUNITIES = "opportunities",
  STATS = "stats",
  PRACTITIONERS_LIST = "practitioners_list"
}

const BaseballCard = observer(({ tab, generalNotes, subTab, backHandler }: { tab: Tab, generalNotes: string, subTab?: string, backHandler?: () => void }) => {
  const [selectedTab, setSelectedTab] = React.useState<Tab>(tab);
  const [isOpen, setIsOpen] = React.useState(false);
  const [showGrade, setShowGrade] = React.useState(false);
  const [isHeaderHidden, setIsHeaderHidden] = React.useState<boolean>(false);
  const [distance, setDistance] = React.useState<number | null>(null);
  const [isCalculatingDistance, setIsCalculatingDistance] = React.useState<boolean>(false);
  const [searchTerm, setSearchTerm] = React.useState('');
  const [isGoRouteModalOpen, setIsGoRouteModalOpen] = React.useState(false);
  const navigate = useNavigate();

  const apiUrl = process.env.REACT_APP_EAI_URL;
  const { postData } = useExternalApiService(apiUrl);

  React.useEffect(() => {
    if (store.checkIn?.practitioner_name) {
      setCurrentPractitioner();
    }
  }, [])

  React.useEffect(() => {
    setIsCalculatingDistance(true);
    /*
    calculteDistance()?.then((distance: number | null) => {
      if (distance !== null) {
        setDistance(distance);
      }
      setIsCalculatingDistance(false);
    }).catch(() => {
      setIsCalculatingDistance(false);
    });
    */
    const promise = calculteDistance();
    if (!promise) {
      // calculteDistance() returned null for some reason—bail out:
      setIsCalculatingDistance(false);
      return;
    }

    promise
      .then((d) => {
        if (d !== null) {
          setDistance(d);
        }
      })
      .catch(() => {
        // geolocation was denied or failed
      })
      .finally(() => {
        setIsCalculatingDistance(false);
      });
      //trackClick("View practitioner");
  }, [store.currentPractitioner]);

  // Pull lat & lon out once so our JSX can read them
  const lat = store.currentPractitioner?.latitude;
  const lon = store.currentPractitioner?.longitude;

  // Helper to track all button clicks with a consistent event
  const trackClick = (section: string) => {
    const label = 'Baseballcard: ' + section
    logEvent(label, { section });
  };

  const calculteDistance = () => {
    if (!lat || !lon) {
      return null;
    }

    // Get current position from browser
    if ("geolocation" in navigator) {
      return new Promise<number>((resolve, reject) => {
        navigator.geolocation.getCurrentPosition((position) => {
          const lat1 = position.coords.latitude;
          const lon1 = position.coords.longitude;
          const lat2 = store.currentPractitioner.latitude;
          const lon2 = store.currentPractitioner.longitude;

          // Calculate distance using Haversine formula
          const R = 6371; // Radius of earth in km
          const dLat = (lat2 - lat1) * Math.PI / 180;
          const dLon = (lon2 - lon1) * Math.PI / 180;
          const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
          const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
          const distance = R * c;

          resolve(Math.round(distance * 0.621371)); // Convert to miles and round
        }, (error) => {
          reject(error);
        });
      });
    }

    return null;
  }
  const setCurrentPractitioner = async () => {
    const result = await postData(`/api/get_practitioner_by_primary_name`, {
      "practitioner_name": store.checkIn?.practitioner_name
    });
    store.setCurrentPractitioner({ ...result.practitioner, general_notes: generalNotes });
  }

  const handleContact = (opt: string) => {
    switch (opt) {
      case 'email':
        window.open(`mailto:${store.currentPractitioner?.email}`, '_blank');
        break;
      case 'phone':
        window.open(`tel:${store.currentPractitioner?.phone}`, '_blank');
        break;
      case 'website':
        window.open(`${store.currentPractitioner?.website}`, '_blank');
        break;
    }
    setIsOpen(false)
  }

  React.useEffect(() => {
    if (selectedTab === Tab.PRACTITIONERS_LIST) {
      setIsHeaderHidden(true);
    } else {
      setIsHeaderHidden(false);
    }

    if (selectedTab) {
      trackClick(`${selectedTab} tab`);
      console.log("tracking ", `${selectedTab}`);
    }
  }, [selectedTab])


  const renderTabContent = () => {
    switch (selectedTab) {
      case Tab.SUMMARY:        
        return <Summary navigate={setSelectedTab} />
      case Tab.NOTES:
        return <Notes />
      case Tab.CHECK_IN:
        return <CheckIn setIsHeaderHidden={setIsHeaderHidden} />
      case Tab.PRACTITIONERS_LIST:        
        return <ListCustomers searchTerm={searchTerm} setSearchTerm={setSearchTerm} onCustomerClick={onCustomerSelected} tab={subTab} />
      case Tab.DETAILS:        
        return <PractitionerDetails navigate={setSelectedTab} />
      case Tab.STATS:        
        return <Stats />
      default:        
        return <Opportunities />
    }
  }

  const onCustomerSelected = (customer: any) => {
    store.setCurrentPractitioner({ ...customer, general_notes: '' });
    setSelectedTab(Tab.SUMMARY);
  }

  const handleRoutes = (opt: string) => {
    if (!store.currentPractitioner) return;
    
    const practitioner = store.currentPractitioner;
    const address = encodeURIComponent(practitioner.address || '');
    const coordinates = `${practitioner.latitude},${practitioner.longitude}`;
    const query = address || coordinates;
    
    switch (opt) {
      case 'google':
        window.open(`https://www.google.com/maps/search/?api=1&query=${query}`, '_blank');
        break;
      case 'waze':
        window.open(`https://waze.com/ul?ll=${practitioner.latitude},${practitioner.longitude}&navigate=yes`, '_blank');
        break;
      case 'apple':
        window.open(`maps://?q=${query}`, '_blank');
        break;
    }
    setIsGoRouteModalOpen(false);
  };

  const isEditable = ((store.currentPractitioner?.status === "LEAD-READY2SUBMIT")  || (store.currentPractitioner.status === "LEAD-INCOMPLETE"))

  return (
    <>
      {(!isHeaderHidden) && (
        <div className={getLeadStateByPractitioner(store.currentPractitioner)  ? styles["tinted-border"] : ""}>
          <div>{getLeadStateByPractitioner(store.currentPractitioner)}</div>
        </div>
      )}
      <div className={styles.wrapper}>
        {(!isHeaderHidden) &&
          <>
            {/*<ExpandIcon style={{ transform: 'rotate(180deg)' }} onClick={
              backHandler ? () =>backHandler() : () => setSelectedTab(Tab.PRACTITIONERS_LIST)
            } 
            width={22} height={22}             
            />*/}
            <LeftIcon 
              onClick={
                backHandler ? () =>backHandler() : () => setSelectedTab(Tab.PRACTITIONERS_LIST)
              } 
              className={styles.leftIcon} />
            <div className={styles.headerWrapper}>
              <div>
                {/*<Text type="header">{store.currentPractitioner?.name}</Text>*/}
                {/*<ArrowLeft fill='black' onClick={() => setSelectedTab(Tab.PRACTITIONERS_LIST)}></ArrowLeft>*/}
                <Text type="header">{store.currentPractitioner?.primary_name}</Text>
                <Text type="subHeader">{store.currentPractitioner?.specialty}</Text>
                <Text width={'140px'} type="subHeader">{`${store.currentPractitioner?.city}, ${store.currentPractitioner?.state}`}</Text>
                <div className={styles.locationWrapper} onClick={() => setIsGoRouteModalOpen(true)}>
                  {/*<Text type="subHeader" width={'100px'}>{`${isCalculatingDistance ? 'Calculating...' : distance ? `${distance} miles away` : 'Distance unavailable'}`}</Text>*/}
                  {isCalculatingDistance
                    ? (<Text type="subHeader" width={"100px"}>Calculating…</Text>)
                    : lat == null || lon == null
                      ? (<div className={styles.missingDistanceWrapper}>
                            <Text type="subHeader" width={"110px"}>Missing distance</Text>
                             <div className={styles.tooltipContainer}>
                              <InfoIcon width={14} height={14} style={{ 
                                marginLeft:0,  
                                padding:0,
                                display:'block'    
                                }} 
                              />
                              <span className={styles.tooltipText}>Latitude & Longitude Missing</span>
                            </div>
                         </div>
                        )
                      : distance == null
                        ? (<div className={styles.missingDistanceWrapper}>
                            <Text type="subHeader" width={"110px"}>Missing distance</Text>
                             <div className={styles.tooltipContainer}>
                              <InfoIcon width={14} height={14} style={{ 
                                marginLeft:0,  
                                padding:0,
                                display:'block'    
                                }} 
                              />
                              <span className={styles.tooltipText}>Did you enable app to use GPS?</span>
                            </div>
                         </div>
                        )
                        : (
                          <div className={styles.distanceWithIcon} onClick={() => setIsGoRouteModalOpen(true)}>
                            <Text type="subHeader" width={"100px"}>{`${distance} miles away`}</Text>
                            <NavigationArrowIcon width={20} height={20} />
                          </div>
                          )
                  }
                  
                  
                </div>

                {isEditable ? (<button 
                  onClick={() => {
                    navigate(`/?${new URLSearchParams({prompt: 'help me create a new lead', toggle: "false", extraArgs: "edit"}).toString()}`);
                  }}
                  className={styles["edit-lead-button"]}>
                  EDIT LEAD
                </button>) : ""}
                {/*
                <Text type="subHeader">{`Last contact: ${date2usDotDate(store.currentPractitioner?.last_contact)}`}</Text>
                */}
              </div>

              <div className={styles.columnWrapper}>
                <div onClick={() => setShowGrade(!showGrade)}
                  className={`${styles.gradeWrapper} ${store.currentPractitioner?.grade === 'A' ? styles.gradeA :
                    store.currentPractitioner?.grade === 'B' ? styles.gradeB :
                      store.currentPractitioner?.grade === 'C' ? styles.gradeC :
                        store.currentPractitioner?.grade === 'D' ? styles.gradeD : styles.gradeNone
                    }`}
                >
                  {showGrade ?
                    <div className={styles.gradeWrapper}>
                      <p className={styles.gradeText}>{store.currentPractitioner?.grade}</p>
                      <p className={styles.gradeText__small}>Grade</p>
                    </div> :
                    <img height='130px' src={store.currentPractitioner?.picture} alt="" />
                  }
                  
                </div>
                <MailIcon onClick={() => setIsOpen(true)} style={{ cursor: 'pointer', paddingTop: '10px' }} />
                <SendTab isOpen={isOpen} setIsOpen={setIsOpen} onSelect={handleContact} />
              </div>
            </div>
            <div className={styles.horizontalScrollWrapper}>
              <div
                onClick={() => setSelectedTab(Tab.SUMMARY)}
                className={`${styles.horizontalScrollItemWrapper} ${selectedTab === Tab.SUMMARY ? styles.selectedTab : styles.disabledTab}`}
              >
                <SummaryIcon />
                <p>Summary</p>
              </div>
              <div
                onClick={() => setSelectedTab(Tab.DETAILS)}
                className={`${styles.horizontalScrollItemWrapper} ${selectedTab === Tab.DETAILS ? styles.selectedTab : styles.disabledTab}`}
              >
                <DetailsIcon />
                <p>Details</p>
              </div>
              <div
                onClick={() => setSelectedTab(Tab.CHECK_IN)}
                className={`${styles.horizontalScrollItemWrapper} ${selectedTab === Tab.CHECK_IN ? styles.selectedTab : styles.disabledTab}`}
              >
                <CheckInIcon />
                <p>Check-In</p>
              </div>
              <div
                onClick={() => setSelectedTab(Tab.NOTES)}
                className={`${styles.horizontalScrollItemWrapper} ${selectedTab === Tab.NOTES ? styles.selectedTab : styles.disabledTab}`}
              >
                <NotesIcon />
                <p>Notes</p>
              </div>
              <div
                onClick={() => setSelectedTab(Tab.OPPORTUNITIES)}
                className={`${styles.horizontalScrollItemWrapper} ${selectedTab === Tab.OPPORTUNITIES ? styles.selectedTab : styles.disabledTab}`}
              >
                <MoneyIcon />
                <p>Opp/Risk</p>
              </div>
              <div
                onClick={() => setSelectedTab(Tab.STATS)}
                className={`${styles.horizontalScrollItemWrapper} ${selectedTab === Tab.STATS ? styles.selectedTab : styles.disabledTab}`}
              >
                <StatsIcon />
                <p>Stats</p>
              </div>
            </div>

          </>
        }
        <div className={styles.tabContentWrapper}>
          {renderTabContent()}
        </div>
        <RoutesTab isOpen={isGoRouteModalOpen} setIsOpen={setIsGoRouteModalOpen} onSelect={handleRoutes} />

      </div>
    </>
  );
});


export default BaseballCard;